import { render } from "./SelectedProduct.vue?vue&type=template&id=9fd8664c&scoped=true&ts=true"
import script from "./SelectedProduct.vue?vue&type=script&lang=ts"
export * from "./SelectedProduct.vue?vue&type=script&lang=ts"

import "./SelectedProduct.vue?vue&type=style&index=0&id=9fd8664c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fd8664c"]])

export default __exports__